
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MaterialPaymentItemsGrid extends Serenity.EntityGrid<MaterialPaymentItemsRow, any> {
        protected getColumnsKey() { return 'Sales.MaterialPaymentItems'; }
        protected getDialogType() { return MaterialPaymentItemsDialog; }
        protected getIdProperty() { return MaterialPaymentItemsRow.idProperty; }
        protected getInsertPermission() { return MaterialPaymentItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialPaymentItemsRow.localTextPrefix; }
        protected getService() { return MaterialPaymentItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }
        
    }
}